import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorAppRatingVm } from '../operator-app-rating-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorAppRatingsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorAppRatings`;
  }

  get(): Observable<IOperatorAppRatingVm[]> {
    const headers = this.createHeaders();
    return this.http.get<IOperatorAppRatingVm[]>(this.baseUrl, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
